require('./stylesheet/style.scss');
require('./stylesheet/refill.scss');

angular.module('pages.history', [])
	.config(config);

config.$inject = ['$stateProvider'];
function config($stateProvider) {
	$stateProvider
		.state('pages.history', {
			url: 'history',
			template: require('./templates/index.html'),
			controller: require('./controllers/history'),
			data: {
				restricted: false,
				iframe: false,
				breadcrumbs: 'MENU.HISTORY'
			},
			params: {
				cardId: null,
                billsHistory: null
			},
			pageTrack: '/history'
		})
}

module.exports = 'pages.history';



/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/history/index.js
 ** module id = 261
 ** module chunks = 1
 **/